import { render } from "./Inner.vue?vue&type=template&id=971d1dd4"
const script = {}
script.render = render

export default script